import Link from 'next/link'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import { StyledContainer, StyledPageWrapper } from './style'

const TermsAndConditionsWrapper: React.FC = () => {
  return (
    <>
      <StyledPageWrapper>
        <StyledContainer>
          <Stack textAlign={'center'} spacing={2}>
            <Typography variant="h5_questions">Terms and Conditions</Typography>
            <Typography
              variant="body_s_regular"
              color={'darkGray.main'}
              aria-label="breadcrumb"
            >
              <Link href={'/r'}>
                <Typography
                  component={'span'}
                  variant="body_s_regular"
                  color={'darkGray.main'}
                  display={'inline-block'}
                >
                  Home
                </Typography>
              </Link>{' '}
              / Terms and Conditions
            </Typography>
          </Stack>
          <Stack mt={9} spacing={5.75}>
            <Stack component={'section'} spacing={3.25}>
              <Typography variant="body_s_regular" color={'darkGray.main'}>
                Please carefully read the following terms and conditions before
                using this website. These terms and conditions apply to all
                users visiting our website. By using this website, you are
                considered to have accepted these terms.
              </Typography>
              <Typography variant="h5_xl">1. Acceptance of Terms</Typography>
              <Typography variant="body_s_regular" color={'darkGray.main'}>
                1.1. By using this website, you acknowledge that you have read,
                understood, and agreed to these Terms in their entirety.
                <br />
                <br />
                1.2. If you are using this website on behalf of an organization,
                you represent and warrant that you have the authority to bind
                that organization to these Terms.
              </Typography>
            </Stack>
            <Stack component={'section'} spacing={3.25}>
              <Typography variant="h5_xl">2. Service Changes</Typography>
              <Typography variant="body_s_regular" color={'darkGray.main'}>
                2.1. You agree to use this website only for lawful purposes and
                in a manner that does not violate any applicable laws or
                regulations.
                <br />
                <br />
                2.2. You are solely responsible for any content you post or
                submit on this website, and you must not engage in any
                activities that may harm, disrupt, or impair the website&apos;s
                functionality.
              </Typography>
            </Stack>
            <Stack component={'section'} spacing={3.25}>
              <Typography variant="h5_xl">4. Intellectual Property</Typography>
              <Typography variant="body_s_regular" color={'darkGray.main'}>
                4.1. All content on this website, including text, graphics,
                logos, images, videos, and software, is the property of Jobin or
                its licensors and is protected by copyright and other
                intellectual property laws.
                <br />
                <br />
                4.2. You may not use, reproduce, distribute, or modify any
                content from this website without prior written consent from
                Jobin.
              </Typography>
            </Stack>
            <Stack component={'section'} spacing={3.25}>
              <Typography variant="h5_xl">
                5. Limitation of Liability
              </Typography>
              <Typography variant="body_s_regular" color={'darkGray.main'}>
                5.1. To the fullest extent permitted by applicable law, [Your
                Company Name] disclaims all warranties, either express or
                implied, regarding the accuracy, reliability, or completeness of
                the content on this website.
                <br />
                <br />
                5.2. Jobin shall not be liable for any direct, indirect,
                incidental, special, consequential, or punitive damages
                resulting from your use of or inability to use this website.
              </Typography>
            </Stack>
            <Stack component={'section'} spacing={3.25}>
              <Typography variant="h5_xl">
                6. Links to Third-Party Websites
              </Typography>
              <Typography variant="body_s_regular" color={'darkGray.main'}>
                6.1. This website may contain links to third-party websites for
                your convenience. [Your Company Name] does not endorse or
                control these third-party websites, and you access them at your
                own risk.
              </Typography>
            </Stack>
            <Stack component={'section'} spacing={3.25}>
              <Typography variant="h5_xl">
                7. Modifications to the Terms
              </Typography>
              <Typography variant="body_s_regular" color={'darkGray.main'}>
                7.1. [Your Company Name] reserves the right to update or modify
                these Terms at any time without prior notice. Your continued use
                of the website after any changes will constitute your acceptance
                of such changes.
              </Typography>
            </Stack>
            <Stack component={'section'} spacing={3.25}>
              <Typography variant="h5_xl">8. Governing Law</Typography>
              <Typography variant="body_s_regular" color={'darkGray.main'}>
                8.1. These Terms are governed by and construed in accordance
                with the laws of [Your Jurisdiction]. Any disputes arising from
                or related to these Terms shall be subject to the exclusive
                jurisdiction of the courts located in [Your Jurisdiction].
              </Typography>
            </Stack>
          </Stack>
        </StyledContainer>
      </StyledPageWrapper>
    </>
  )
}

export default TermsAndConditionsWrapper
